interface BringForwardIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export default function BringForwardIcon(props: BringForwardIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      className="icon"
      {...props}>
      {props.title && <title>{props.title}</title>}
      <path d="M3 3v12h7v7h7v7h12V17h-7v-7h-7V3zm9 9h8v8h-8z" />
    </svg>
  )
}
